import { Link, FC } from 'external/react'
import Icon from 'external/fortawesome'
import CourseCover from 'components/CourseCover'

type CourseLinkProps = {
    id: string
    selected: boolean
    name: string
}

const CourseLink : FC<CourseLinkProps> = props => {
    const {id, selected, name} = props
    return (
        <Link to={`/course-detail/${id}`}>
            <div className='courseContent'>
                {selected && (
                    <div className='courseTag'>
                        <span className='badge badge-success'>
                            <Icon name='faCircleCheck' className='mr-1' />
                            Seleccionado
                        </span>
                    </div>
                )}
                <CourseCover id={id} name={name} />
            </div>
        </Link>
    )
}

export {CourseLink as default}